import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class AccountService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens(groupCd?: string, shatenCd?: string) {
        let path = `${this.baseAPI}/kyotens-account`;
        if (groupCd && shatenCd) {
            path += "?groupCd=" + groupCd;
            path += "&shatenCd=" + shatenCd;
        } else if (groupCd) {
            path += "?groupCd=" + groupCd;
        } else if (shatenCd) {
            path += "?shatenCd=" + shatenCd;
        }
        const { result, error } = await this.commonService.get(path);
        if (result) {
        return result.data;
        } else {
        return this.authService.handleError(error, "getKyotens");
        }
    }

    public async getShatens(groupCd?: string) {
        let path = `${this.baseAPI}/shatens`;
        if (groupCd) {
            path += "?groupCd=" + groupCd;
        }
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            return this.authService.handleError(error, "getShatens");
        }
    }

    public async getGroups() {
        const { result, error } = await this.commonService.get(`${this.baseAPI}/groups`);
        if (result) {
            return {
                data: result.data,
                groupCd: result.headers.login_group_code || "",
                shatenCd: result.headers.login_shaten_code || "",
                loginType: result.headers.login_type_kbn || ""
            };
        } else {
            return this.authService.handleError(error, "getGroups");
        }
    }

    public async getAccount(id?: number, filter?: any) {
        let url = `${this.baseAPI}/accounts`;
        
        if (id) {
            url += `/${id}`;
        }

        if (filter) {
            let query: string[] = [];
            Object.keys(filter).forEach((key: string) => {
                if (filter[key]) {
                    query.push(`${key}=${filter[key]}`);
                }
            });
            if (query.length) {
                url += `?${query.join("&")}`;
            }
        }


        const { result, error } = await this.commonService.get(url);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getAccount');
            return;
        }
    }

    public async addAccount(data: any) {
        return this.commonService.post(`${this.baseAPI}/accounts/`, data);
    }

    public async deleteAccount(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/accounts/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteAccount');
            return;
        }
    }

    public async updateAccount(data: any) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/accounts`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'updateAccount');
            return;
        }
    }

    public async restoreAccount(id: string) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/restore-account/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'restoreAccount');
            return;
        }
    }

    // ============================





}
